import React, { useState, useEffect } from "react";
import "../Pages/Services.css";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { Helmet } from "react-helmet";

import VAN5 from "../images/VAN6.jpg";
import VAN6 from "../images/VAN7.jpg";
import VAN7 from "../images/VAN8.jpg";
import VAN8 from "../images/VAN9.jpg";
import VAN9 from "../images/VAN10.jpg";
import VAN51 from "../images/VAN51.jpg";
import VAN52 from "../images/VAN52.jpg";
import VAN53 from "../images/VAN53.jpg";
import VAN54 from "../images/VAN54.jpg";
import VAN55 from "../images/VAN55.jpg";

import {
  FaPhoneAlt,
  FaWhatsapp,
  FaArrowLeft,
  FaArrowRight,
  FaStar,
} from "react-icons/fa";

export default function Services() {
  // --------------- IMAGE POOL REUSABLE -----------------
  const imgPool = [
    VAN5,
    VAN6,
    VAN7,
    VAN8,
    VAN9,
    VAN51,
    VAN52,
    VAN53,
    VAN54,
    VAN55,
  ];

  const pickImages = (start = 0) => {
    const arr = [];
    for (let i = 0; i < 5; i++) {
      arr.push(imgPool[(start + i) % imgPool.length]);
    }
    return arr;
  };

  // --------------- VEHICLE DATA -----------------

  const vans = [
    {
      id: "van-1",
      title: "Executive Traveller Van (A-Series)",
      seats: "12+1",
      luggage: "12 Bags",
      ac: true,
      price: "₹18/km",
      images: pickImages(0),
      featured: true,
      description:
        "Our most booked van — cinematic ride, wide interiors, premium comfort.",
    },
    {
      id: "van-2",
      title: "Family Traveller Van (B-Series)",
      seats: "10+1",
      luggage: "10 Bags",
      ac: true,
      price: "₹16/km",
      images: pickImages(2),
      featured: false,
      description:
        "Perfect for family trips, temple visits and short-travel routes.",
    },
    {
      id: "van-3",
      title: "Deluxe Minivan (C-Series)",
      seats: "9+1",
      luggage: "8 Bags",
      ac: true,
      price: "₹15/km",
      images: pickImages(4),
      featured: false,
      description: "Soft seats, clean interiors, ideal for airport transfers.",
    },
    {
      id: "van-4",
      title: "Luxury Traveller (D-Series)",
      seats: "14+1",
      luggage: "14 Bags",
      ac: true,
      price: "₹20/km",
      images: pickImages(6),
      featured: false,
      description: "High-end ride with maximum comfort and legroom.",
    },
    {
      id: "van-5",
      title: "Economy Van (E-Series)",
      seats: "8+1",
      luggage: "7 Bags",
      ac: true,
      price: "₹14/km",
      images: pickImages(8),
      featured: false,
      description: "Budget-friendly van for all small group travel.",
    },
  ];

  const cars = [
    {
      id: "car-1",
      title: "Sedan – Comfort",
      seats: "4+1",
      luggage: "2 Bags",
      ac: true,
      price: "₹12/km",
      images: pickImages(1),
      description: "Best for couples and short family travel.",
    },
    {
      id: "car-2",
      title: "SUV – Family",
      seats: "6+1",
      luggage: "6 Bags",
      ac: true,
      price: "₹15/km",
      images: pickImages(3),
      description: "Perfect for family trips and hill station routes.",
    },
    {
      id: "car-3",
      title: "Innova – Premium",
      seats: "7+1",
      luggage: "7 Bags",
      ac: true,
      price: "₹16/km",
      images: pickImages(5),
      description: "Most preferred for long-distance luxury travel.",
    },
    {
      id: "car-4",
      title: "Luxury Sedan",
      seats: "4+1",
      luggage: "3 Bags",
      ac: true,
      price: "₹20/km",
      images: pickImages(7),
      description: "Premium business-class comfort & leather seats.",
    },
    {
      id: "car-5",
      title: "Compact City Car",
      seats: "4+1",
      luggage: "2 Bags",
      ac: true,
      price: "₹10/km",
      images: pickImages(9),
      description: "Best for inside-city usage & quick travel.",
    },
  ];

  // --------------- IMAGE INDEX HANDLING -----------------

  const init = {};
  [...vans, ...cars].forEach((v) => (init[v.id] = 0));
  const [indices, setIndices] = useState(init);

  const prevImg = (id, arr) => {
    setIndices((p) => ({
      ...p,
      [id]: (p[id] - 1 + arr.length) % arr.length,
    }));
  };

  const nextImg = (id, arr) => {
    setIndices((p) => ({
      ...p,
      [id]: (p[id] + 1) % arr.length,
    }));
  };

  const setImg = (id, i) => {
    setIndices((p) => ({ ...p, [id]: i }));
  };

  // --------------- AUTO PLAY FOR FEATURED VAN -----------------

  useEffect(() => {
    const fv = vans.find((v) => v.featured);
    if (!fv) return;

    const id = fv.id;
    const timer = setInterval(() => {
      setIndices((p) => ({
        ...p,
        [id]: (p[id] + 1) % fv.images.length,
      }));
    }, 4000);

    return () => clearInterval(timer);
  }, []);

  const phone = "9095223243";
  const wa = `https://wa.me/91${phone}`;

  return (
    <>
 <Helmet>
  <title>Van & Car Rental Services in Aruppukottai | Sri Rajalakshmi Travels</title>

  <meta
    name="description"
    content="Choose from 5 vans and 5 cars for rental in Aruppukottai. Force Traveller, Tempo Traveller, Sedan, SUV, AC/Non-AC vans & experienced drivers. Book 24/7."
  />

  <meta
    name="keywords"
    content="van rental Aruppukottai, tempo traveller Aruppukottai, force traveller booking, car rental Aruppukottai, 12 seater van, 17 seater van hire, tourist van Aruppukottai, Aruppukottai vehicle rental"
  />

  <link rel="canonical" href="https://srirajalakshmitravels.in/services" />

  {/* TRAVEL AGENCY SCHEMA */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "TravelAgency",
      name: "Sri Rajalakshmi Travels",
      image: "https://srirajalakshmitravels.com/static/media/SRILOGO.538e1e7c6643833d5ce3.png",
      url: "https://srirajalakshmitravels.in",
      telephone: "+91 90952 23243",
      address: {
        "@type": "PostalAddress",
        streetAddress: "12/4 Main Road",
        addressLocality: "Aruppukottai",
        addressRegion: "Tamil Nadu",
        postalCode: "626101",
        addressCountry: "IN"
      },
      openingHours: "Mo-Su 00:00-23:59",
      priceRange: "₹₹",
      sameAs: [
        "https://www.facebook.com/",
        "https://www.instagram.com/"
      ]
    })}
  </script>

  {/* SERVICE SCHEMA */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Service",
      serviceType: "Van Rental, Car Rental, Tourist Vehicle Booking",
      provider: {
        "@type": "TravelAgency",
        name: "Sri Rajalakshmi Travels",
      },
      areaServed: "Aruppukottai, Virudhunagar",
      hasOfferCatalog: {
        "@type": "OfferCatalog",
        name: "Travel Services",
        itemListElement: [
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Van Rental in Aruppukottai",
            },
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Car Rental in Aruppukottai",
            },
          },
          {
            "@type": "Offer",
            itemOffered: {
              "@type": "Service",
              name: "Tour Package Booking",
            },
          },
        ],
      },
    })}
  </script>
</Helmet>


      <Navbar />

      <main className="services-page">

        {/* ================= HERO ================= */}
        <section className="hero-services">
          <div className="container">
            <h1 className="services-main-title">Our Fleet — Vans & Cars</h1>
            <p className="services-sub">
              Rental Van in Aruppukottai • Best Travels in Aruppukottai • Book
              instantly via Call or WhatsApp.
            </p>
          </div>
        </section>

        {/* ================= CLIENT SECTION ================= */}
        <section className="client-box">
          <div className="container client-inner">
            <div className="client-left">
              <h3>SRI RAJALAKSHMI TRAVELS</h3>
              <p className="client-owner">Owner: Mr. Rajalakshmi • 10+ Years</p>
              <p className="client-note">
                Trusted travel service for Aruppukottai & Tamil Nadu — safety,
                comfort & punctuality guaranteed.
              </p>
            </div>

            <div className="client-right">
              <a className="btn-call" href={`tel:${phone}`}>
                <FaPhoneAlt /> Call to Book
              </a>
              <a
                className="btn-wa"
                href={wa}
                target="_blank"
                rel="noreferrer"
              >
                <FaWhatsapp /> WhatsApp
              </a>
            </div>
          </div>
        </section>

        {/* ================= VAN SECTION ================= */}
        <section className="vehicles-section">
          <div className="container">
            <h2 className="section-title">Premium Vans</h2>

            <div className="vehicle-list">
              {vans.map((v, i) => {
                const idx = indices[v.id];
                return (
                  <article
                    key={v.id}
                    className={`vehicle-card ${v.featured ? "featured" : ""}`}
                  >
                    <div className="vehicle-media">
                      <div className="media-wrap">
                        <img
                          src={v.images[idx]}
                          alt={v.title}
                          className="media-main"
                        />

                        {v.featured && (
                          <div className="featured-badge">
                            <FaStar /> Most Booked
                          </div>
                        )}

                        <button
                          className="media-arrow left"
                          onClick={() => prevImg(v.id, v.images)}
                        >
                          <FaArrowLeft />
                        </button>
                        <button
                          className="media-arrow right"
                          onClick={() => nextImg(v.id, v.images)}
                        >
                          <FaArrowRight />
                        </button>
                      </div>

                      <div className="thumbs">
                        {v.images.map((img, t) => (
                          <button
                            key={t}
                            className={`thumb ${t === idx ? "active" : ""}`}
                            onClick={() => setImg(v.id, t)}
                          >
                            <img src={img} />
                          </button>
                        ))}
                      </div>
                    </div>

                    <div className="vehicle-info">
                      <h3 className="vehicle-title">{v.title}</h3>
                      <p className="vehicle-desc">{v.description}</p>

                      <ul className="vehicle-meta">
                        <li>Seats: {v.seats}</li>
                        <li>Luggage: {v.luggage}</li>
                        <li>AC: {v.ac ? "Yes" : "No"}</li>
                        <li>Price: {v.price}</li>
                      </ul>

                      <div className="vehicle-actions">
                        <a className="btn btn-primary" href={`tel:${phone}`}>
                          <FaPhoneAlt /> Call Now
                        </a>
                        <a className="btn btn-outline" href={wa}>
                          <FaWhatsapp /> WhatsApp
                        </a>
                      </div>
                    </div>
                  </article>
                );
              })}
            </div>
          </div>
        </section>

        {/* ================= CARS ================= */}
        <section className="vehicles-section">
          <div className="container">
            <h2 className="section-title">Premium Cars</h2>

            <div className="vehicle-list">
              {cars.map((v, i) => {
                const idx = indices[v.id];
                return (
                  <article key={v.id} className="vehicle-card">
                    <div className="vehicle-media">
                      <div className="media-wrap">
                        <img
                          src={v.images[idx]}
                          alt={v.title}
                          className="media-main"
                        />

                        <button
                          className="media-arrow left"
                          onClick={() => prevImg(v.id, v.images)}
                        >
                          <FaArrowLeft />
                        </button>
                        <button
                          className="media-arrow right"
                          onClick={() => nextImg(v.id, v.images)}
                        >
                          <FaArrowRight />
                        </button>
                      </div>

                      <div className="thumbs">
                        {v.images.map((img, t) => (
                          <button
                            key={t}
                            className={`thumb ${t === idx ? "active" : ""}`}
                            onClick={() => setImg(v.id, t)}
                          >
                            <img src={img} />
                          </button>
                        ))}
                      </div>
                    </div>

                    <div className="vehicle-info">
                      <h3 className="vehicle-title">{v.title}</h3>
                      <p className="vehicle-desc">{v.description}</p>

                      <ul className="vehicle-meta">
                        <li>Seats: {v.seats}</li>
                        <li>Luggage: {v.luggage}</li>
                        <li>AC: {v.ac ? "Yes" : "No"}</li>
                        <li>Price: {v.price}</li>
                      </ul>

                      <div className="vehicle-actions">
                        <a className="btn btn-primary" href={`tel:${phone}`}>
                          <FaPhoneAlt /> Call Now
                        </a>
                        <a className="btn btn-outline" href={wa}>
                          <FaWhatsapp /> WhatsApp
                        </a>
                      </div>
                    </div>
                  </article>
                );
              })}
            </div>
          </div>
        </section>

        {/* ================= BOOKING NOTE ================= */}
        <section className="booking-note">
          <div className="container">
            <h3>How to Book</h3>
            <p>
              Call or WhatsApp us anytime — 24/7 service available. Provide
              pickup, drop, journey date & time. Transparent pricing, no hidden
              charges.
            </p>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}
